import React from 'react'

const Show = (props) => {
  return (
     <>
  <div className='container'>
            <div className="row my-2">

                <div className="col-6">
                    <h6>{props.task}</h6>
                </div>
                <div className="col-6">
                <button className='btn btn-primary' onClick={()=>{
                    props.onSelect(props.id)
                }}>Delete Todo</button>
                </div>
            </div>
            
        </div>     
     
     </>

    )
}

export default Show